import React, { useEffect, useEffectEvent, useState, useRef } from "react";
import { createPortal } from "react-dom";
import "../Style/Component/menu.css";
import dash from "../Assets/menu/dash.svg";
import driverm from "../Assets/menu/driverm.svg";
import customerm from "../Assets/menu/customerm.svg";
import ridem from "../Assets/menu/ridem.svg";
import approval from "../Assets/menu/approve1.png";
import wallet from "../Assets/menu/wallet.svg";
import message from "../Assets/menu/message.svg";
import splash from "../Assets/menu/splash.svg";
import account from "../Assets/menu/account.svg";
import announcement from "../Assets/menu/announcement.svg";
import logo from "../Assets/menu/Grabit.svg";
import search from "../Assets/rider/search.svg";
import notification from "../Assets/menu/notification.svg";
import logouticon from "../Assets/menu/logout.svg";
import role from "../Assets/menu/role.png";
import resource from "../Assets/menu/resource1.webp";
import support from "../Assets/menu/support.png";
import loc from "../Assets/menu/location.svg";
import walletrequest from "../Assets/menu/walletrequest.svg";
import versioncontrol from "../Assets/menu/versioncontrol.svg";
// import prices from '../Assets/menu/'
import Approutes from "../routes/Approutes";
import { NavLink, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../Store/authSlicer";
import { useSelector } from "react-redux";
import { getWithTokenAPI, putWithTokenAPI } from "../Util/Api";
import { setProfile } from "../Store/ProfileSlicer";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Headset, Bell, X, Info, Clock } from "lucide-react";
import { IoNotificationsOutline } from "react-icons/io5";
const Menu = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const adminId = auth.userId;
  const permission = auth.permission;
  const profile = useSelector((state) => state.profile.profile);
  const [shownotification, setShowNotification] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [readstatus, setReadStatus] = useState(true);
  const [activenoti, setActivenoti] = useState("all");
  const [searchText, setSearchText] = useState("");
  const [noticount, setNotiCount] = useState(0);
  console.log(noticount, 'noticountnoticountnoticount')
  const searchRef = useRef(null);
  const [dropdownStyle, setDropdownStyle] = useState({});
  const menuitems = [
    { key: "dashboard", icon: dash, title: "Dashboard", path: "/admin" },
    {
      key: "drivermanagement",
      icon: driverm,
      title: "Driver Management",
      path: "/admin/drivers",
    },
    {
      key: "customermanagement",
      icon: customerm,
      title: "Customer Management",
      path: "/admin/customer",
    },
    {
      key: "ridemanagement",
      icon: ridem,
      title: "Ride Management",
      path: "/admin/rides",
    },
    { key: "approval", icon: approval, title: "Approval", path: "/admin/approval" },
    { key: "rolemanagement", icon: role, title: "Roles", path: "/admin/roles" },
    {
      key: "resouragemangement",
      icon: resource,
      title: "Resource",
      path: "/admin/resource",
    },
    { key: "prices", icon: ridem, title: "Prices", path: "/admin/prices" },
    { key: "wallet", icon: wallet, title: "Wallet", path: "/admin/wallet" },
    { key: "message", icon: message, title: "Message", path: "/admin/messages" },
    { key: "location", icon: loc, title: "Location", path: "/admin/location" }, // only if exists in backend
    {
      key: "splash_screen",
      icon: splash,
      title: "Splash Screen",
      path: "/admin/splash",
    },
    { key: "helpandsupport", icon: support, title: "Support", path: "/admin/help" },
    { key: "account", icon: announcement, title: "Announcement", path: "/admin/announcement" },

    { key: "account", icon: walletrequest, title: "Walletrequest", path: "/admin/request" },
    { key: "logoandtermsCondition", icon: resource, title: "CMS Management", path: "/admin/cms" },
    { key: "versioncontrol", icon: versioncontrol, title: "Version Control", path: "/admin/version-control" },
    { key: "account", icon: account, title: "Account", path: "/admin/account" },
  ];
  const filteredItems = menuitems
    .filter((item) => permission?.[item.key]?.view ?? true)
    .filter((item) =>
      item.title.toLowerCase().includes(searchText.toLowerCase()),
    );
  useEffect(() => {
    const fetchadmindetails = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/user/profile/${adminId}`,
        );
        const adminProfile = response?.data;
        dispatch(setProfile(adminProfile));
        console.log(profile, "profile from redux");
      } catch {
        console.log("Error in fetching Limit Api");
      }
    };
    fetchadmindetails();
  }, [token]);

  const fetchnotification = async () => {
    try {
      const response = await getWithTokenAPI(
        token,
        `/notification/list-all?message_for=admin&is_read=${readstatus}`,
      );
      setNotifications(response?.data?.notifications);
      setNotiCount(response?.data?.unreadCount);
    } catch {
      console.log("Error in fetching Limit Api");
    }
  };
  useEffect(() => {
    fetchnotification();
  }, [token, readstatus]);

  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMin = Math.floor(diffMs / 60000);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);

    if (diffDay > 0) return `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;
    if (diffHour > 0) return `${diffHour} hour${diffHour > 1 ? "s" : ""} ago`;
    if (diffMin > 0) return `${diffMin} minute${diffMin > 1 ? "s" : ""} ago`;
    return "Just now";
  };

  useEffect(() => {
    if (searchText && searchRef.current) {
      const rect = searchRef.current.getBoundingClientRect();

      setDropdownStyle({
        position: "fixed",
        top: rect.bottom + 5 + "px",
        left: rect.left + "px",
        width: rect.width + "px",
        zIndex: 999999,
      });
    }
  }, [searchText]);

  const handleLogout = () => {
    toast.success("Admin logout Successfully");
    localStorage.removeItem("token");
    dispatch(logout());
    navigate("/admin/login");
  };
  const handleLogoutConfirm = () => {
    Swal.fire({
      title: "Logout?",
      text: "Are you Sure to Logout",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(168, 44, 44)",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleLogout();
      }
    });
  };


  const [applogo, setApplogo] = useState("");
  const [logoid, setLogoId] = useState("");
  const fetchLogo = async () => {
    try {
      const res = await getWithTokenAPI(token, `/logo`);
      setApplogo(res?.data?.[0]?.logo || "");
      setLogoId(res?.data?.[0]?._id || "");
    } catch (error) {
      console.error("Failed to fetch logo:", error);
    }
  };
  useEffect(() => {
    fetchLogo();
  }, []);
  const routeMap = {
    3003: "/approval",
    3007: "/customer",
    3005: "/rides",
    3008: "/resource",
    3009: "/prices",
    3010: "/wallet",
    3011: "/messages",
    3012: "/drivers",
    3013: "/splash",
    3014: "/help",
    3015: "/announcement",
    3016: "/request",
    3017: "/account",
  };

  const HandleNotificationClick = async (id) => {
    try {
      const payload = { is_read: true };

      const res = await putWithTokenAPI(
        token,
        `/notification/update/${id}`,
        payload
      );

      if (res?.statusCode === 200) {
        fetchnotification();
        setShowNotification(false)
        const code = res?.data?.message_code;
        const path = routeMap[code];

        if (path) {
          navigate(path);
        }
      }
    } catch (error) {
      console.error("Failed to update notification:", error);
    }
  };
  return (
    <div className="layout">
      {/* TOP BAR */}
      <div className="topbar">
        <div className="topbar-title" onClick={() => navigate("/admin")}>
          <div className="logo-icon">
            <img src={applogo} alt="App Logo" />
          </div>

          <div className="logo-text">
            <img src={logo} alt="Grabit Logo" />
          </div>
        </div>

        <div className="topbarright">
          <div className="searchbar" ref={searchRef}>
            <input
              type="search"
              placeholder="Search menu..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <span className="searchlens">
              <img src={search} alt="search" />
            </span>

            {searchText &&
              createPortal(
                <div style={dropdownStyle} className="search-results">
                  {filteredItems.length > 0 ? (
                    filteredItems.map((item, index) => (
                      <div
                        key={index}
                        className="search-item"
                        onClick={() => {
                          navigate(item.path);
                          setSearchText("");
                        }}
                      >
                        <img src={item.icon} alt="" />
                        <span>{item.title}</span>
                      </div>
                    ))
                  ) : (
                    <div className="search-item">No menu found</div>
                  )}
                </div>,
                document.body,
              )}
          </div>

          <div className="naviconsbuttons">
            <img
              src={notification}
              alt="notification"
              onClick={() => {
                setShowNotification(!shownotification);
              }}
            />
            {noticount > 0 && (
              <span className="notification-count-header">
                {noticount > 99 ? "99+" : noticount}
              </span>
            )}
          </div>
          <img
            src={logouticon}
            alt="logout"
            onClick={() => handleLogoutConfirm()}
          />
          {shownotification &&
            createPortal(
              <>
                <div
                  className={`notification-backdrop ${shownotification ? "show" : ""
                    }`}
                  onClick={() => setShowNotification(false)}
                />

                <div
                  className={`notification-panel ${shownotification ? "open" : ""
                    }`}
                >
                  {/* Header */}
                  <div className="notification-header">
                    <h3>
                      <Bell size={22} />
                      Notifications
                      {noticount > 0 && (
                        <span className="notification-count">
                          {noticount}
                        </span>
                      )}
                    </h3>

                    <button
                      className="close-btn"
                      onClick={() => setShowNotification(false)}
                    >
                      <X size={18} color="white" />
                    </button>
                  </div>

                  {/* Tabs */}
                  <div className="notitabs-container">
                    <div className="notitabs">
                      <span
                        className={`notihead ${activenoti === "all" ? "activenoti" : ""}`}
                        onClick={() => {
                          setReadStatus(true);
                          setActivenoti("all");
                        }}
                      >
                        All
                      </span>
                      <span
                        className={`notihead ${activenoti === "unread" ? "activenoti" : ""}`}
                        onClick={() => {
                          setReadStatus(false);
                          setActivenoti("unread");
                        }}
                      >
                        Unread
                      </span>
                    </div>
                  </div>

                  {/* List */}
                  <div className="notification-list-container">
                    {loading ? (
                      <div className="notification-loading">Loading...</div>
                    ) : notifications?.length > 0 ? (
                      notifications?.map((notification) => (
                        <div
                          key={notification._id}
                          onClick={(() => { HandleNotificationClick(notification._id) })}
                          className={`notification-item ${!notification.is_read ? "unread" : ""
                            }`}
                        >
                          <div className="noti-icon-wrapper">
                            <Info size={20} />
                          </div>
                          <div
                            className="notification-content">
                            <div className="notification-title-row">
                              <h4>
                                {notification.heading?.en || "Notification"}
                              </h4>
                              <span className="notification-time">
                                <Clock size={12} />
                                {formatTimeAgo(notification.createdAt)}
                              </span>
                            </div>
                            <p>
                              {notification.content?.en ||
                                "Notification content"}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="notification-empty">
                        <IoNotificationsOutline style={{ fontSize: "60px", opacity: 0.5 }} />
                        <h4>No notifications found</h4>
                        <p>When you have new notifications, they'll appear here.</p>
                      </div>
                    )}
                  </div>
                </div>
              </>,
              document.body,
            )}

          <div className="profile" onClick={() => navigate("/admin/account")}>
            <span>
              <h2>{profile?.name}</h2>
              <h3>{profile?.location1?.[0]?.city}</h3>
            </span>
            <img src={profile?.profileimage} alt="profile" />
          </div>
        </div>
      </div>

      {/* SIDEBAR */}
      <div className="sidebar">
        {menuitems
          .filter((menu) => permission?.[menu.key]?.view ?? true)
          .map((menu) => {
            const isActive =
  menu.path === "/admin"
    ? location.pathname === "/admin"
    : location.pathname.startsWith(menu.path);
            return (
              <NavLink
                 to={menu.path}
  end={menu.path === "/admin"}
  key={menu.title}
  className={({ isActive }) =>
    `sidebar-item ${isActive ? "active" : ""}`
  }>
                <img
                  src={menu.icon}
                  alt={menu.title}
                  style={{
                    width: "25px",
                    height: "25px",
                    color: "grey",
                  }}
                />
                <span className="menuname">{menu.title}</span>
              </NavLink>
            );
          })}
      </div>

      <div className="mainarea">
        <Approutes />
      </div>
    </div>
  );
};

export default Menu;
